import { render, staticRenderFns } from "./roles-card.vue?vue&type=template&id=a09ee0ea&"
import script from "./roles-card.vue?vue&type=script&lang=js&"
export * from "./roles-card.vue?vue&type=script&lang=js&"
import style0 from "./roles-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports